import {IsEmptyVar} from '../defines/common.func';

export class SimpleProverb {
  id: string;
  proverb2: string;
  proverb3: string;
  meaning2: string;

  constructor(obj?: any) {
    this.id           = (obj && obj.id)           ?? null;
    this.proverb2     = (obj && obj.proverb2)     ?? null;
    this.proverb3     = (obj && obj.proverb3)     ?? null;
    this.meaning2     = (obj && obj.meaning2)     ?? null;
  }

  offsetTop?: number; // 단어가 화면에 표시되는 위치 (단어가 화면에 표시되는 위치를 저장한다. 속도 향상을 위해서 저장.)
}



export class Proverb extends SimpleProverb {
  meaning3: string;
  bookmark: boolean;

  constructor(obj?: any) {
    super(obj);
    this.meaning3     = (obj && obj.meaning3)     ?? null;
    this.bookmark     = (obj && !IsEmptyVar(obj.bookmark)) ? !!obj.bookmark : false;
  }
}
